module.exports = __webpack_public_path__ + "media/images/icon-error-ba6bdb5b07e1a444d445309d24ed1c0f.svg";